import { useState } from "react";
import { Filialenwahl, ServicePicker, ServiceDetails, Kundendaten, FormDatePicker, BookingSuccess } from "./FormFunctions";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { useForm } from "react-hook-form";

export default function Form(props) {


  window.addEventListener('unload', function (event) {
    sessionStorage.clear();
  });



  const [arePagesOneAndTwoFilled, setArePagesOneAndTwoFilled] = useState(false);
  const checkPagesOneAndTwoFilled = () => {
    const pageOneFilled = isPreviousPageFilled(1);
    const pageTwoFilled = isPreviousPageFilled(2);
    setArePagesOneAndTwoFilled(pageOneFilled && pageTwoFilled);
  };

  const services = props.services;
  const standorte = props.standorte;
  const lastPage = 4;

  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const onSubmit = data => console.log(data);

  const [page, setPage] = useState(0);
  const [service, setService] = useState({ id: -1, arbeitseinheiten: 0, name: "" });
  const [standort, setStandort] = useStateWithCallbackLazy({});
  const [datum, setDatum] = useState(null);
  const [fzgDaten, setFzgDaten] = useState({ erstzulassung: "", fzg_id: "", km_stand: "", letzter_servicetermin: "", letzter_km_stand: "" });
  const [persDaten, setPersDaten] = useState({ vorname: "", nachname: "", adresse: "", tel: "", email: "", einwilligung: false });

  const [finalFormData, setFinalFormData] = useState({});

  function formSubmit(e) {
    const requestBody = {
      ...persDaten,
      service: service.id,
      datum: datum,
      ...fzgDaten,
      standort: standort.name,
    };
    console.log(requestBody);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };
    fetch('items/buchung', requestOptions)
      .then(response => response.json())
      .then(data => console.log(data));
  }

  function handleClickBreadcrumb(clickedPage) {
    if (clickedPage < page) {
      setPage(clickedPage);
      checkPagesOneAndTwoFilled(); // Проверка заполненности данных на первых двух страницах
      return;
    }
    //else: do nothing.
  }

  function formatDate(date) {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    let formattedDate = date.toLocaleDateString('de-DE', options);
    formattedDate = formattedDate.replace(/\./g, '');
    return formattedDate;

  }


  const currentData = () => {
    return <>
      <div className="data-overview opensans-regular font-size150">
        <h2>Ihre Eingaben</h2>
        <div className="previewField">
          <p>Standort</p>
          <p><b>{standort.anzeigename}</b></p>
        </div>
        <div className="previewField">
          <p>Service</p>
          <p><b>{service.name}</b></p>
        </div>
        <div className="previewField">
          <p>Datum</p>
          <p><b>{datum && formatDate(datum)}</b></p>
        </div>
        <div className="previewField">
          <p>Name</p>
          <p><b>{persDaten.vorname} {persDaten.nachname}</b></p>
        </div>
        <div className="previewField">
          <p>Mobilnummer</p>
          <p><b>{persDaten.tel}</b></p>
        </div>
        <div className="previewField">
          <p>Email</p>
          <p><b>{persDaten.email}</b></p>
        </div>
      </div>
    </>

  }

  const conditionalComponent = () => {
    switch (page) {
      case 0:
        return <Filialenwahl formData={standort} setFormData={setStandort} standorte={standorte} setPage={setPage} pageNum={0} finalFormData={finalFormData} setFinalFormData={setFinalFormData} resetDate={() => {
          setDatum(null);
          sessionStorage.removeItem('selectedDate');
          // localStorage.removeItem('letzter_servicetermin');
          // localStorage.removeItem('erstzulassung');
          // setFzgDaten(prevData => ({
          //   ...prevData,
          //   letzter_servicetermin: null,
          //   erstzulassung: null
          // }));
        }}

        ></Filialenwahl>;
      case 1:
        return <ServicePicker state={service} setState={setService} options={services} fzgState={fzgDaten} formData={fzgDaten} setFormData={setFzgDaten} setPage={setPage} pageNum={1} finalFormData={finalFormData} setFinalFormData={setFinalFormData} />
      case 2:
        return <FormDatePicker formData={datum} setFormData={setDatum} standortState={standort} serviceState={service} setPage={setPage} pageNum={2} finalFormData={finalFormData} setFinalFormData={setFinalFormData}></FormDatePicker>;
      case 3:
        return <Kundendaten state={persDaten} setState={setPersDaten} setPage={setPage} finalFormData={finalFormData} setFinalFormData={setFinalFormData} />;
      case 4:
        return <><div>
          <p>Pers. Daten: {JSON.stringify(persDaten)}</p>
          <p>Fahrzeugdaten: {JSON.stringify(fzgDaten)}</p>
          <p>Service: {JSON.stringify(service)}</p>
          <p>Standort: {JSON.stringify(standort)}</p>
          <p>Datum: {JSON.stringify(datum)}</p>
        </div></>;
      case 10:
        return <BookingSuccess email={persDaten.email}></BookingSuccess>
      default:
        return <></>;
    }
  };

  const isPreviousPageFilled = (pageNum) => {
    switch (pageNum) {
      case 1:
        return !!standort.name && !!service.id && !!fzgDaten.km_stand && !!fzgDaten.fzg_id && !!fzgDaten.erstzulassung;
      case 2:
        return !!standort.name && !!service.id && !!fzgDaten.km_stand && !!fzgDaten.fzg_id && !!fzgDaten.erstzulassung && !!datum; // Добавляем условие заполненности для первой и второй страниц
      case 3:
        return !!standort.name && !!service.id && !!datum && !!persDaten.vorname && !!persDaten.nachname && !!persDaten.tel && !!persDaten.email; // Проверяем, что первая, вторая и третья страницы заполнены
      case 4:
        return !!standort.name && !!service.id && !!datum && !!persDaten.vorname && !!persDaten.nachname && !!persDaten.tel && !!persDaten.email; // Проверяем, что все предыдущие страницы заполнены
      default:
        return true;
    }
  };


  const getBreadCrumbClassName = (pageNum) => {
    let name = "breadcrumb-circle";
    if (page === pageNum) {
      name = name + " active";
    } else if (!isPreviousPageFilled(pageNum)) {
      name = name + " disabled";
    }
    return name;
  };

  return (
    <div id="form" className="date-picker-wrapper">
      <div className="breadcrumbs">
        <button
          className={getBreadCrumbClassName(0)}
          onClick={() => setPage(0)}
          disabled={!isPreviousPageFilled(0)}
          aria-label="Schritt 1"
        >
          <p>1</p>
        </button>

        {/* Отображать линию только если текущая страница >= 1 */}
        {page >= 1 && (
          <div className="breadLine1"></div>
        )}

        <button
          className={getBreadCrumbClassName(1)}
          onClick={() => setPage(1)}
          disabled={!isPreviousPageFilled(1)}
          aria-label="Schritt 2"
        >
          <p>2</p>
        </button>

        {/* Отображать линию только если текущая страница >= 2 */}
        {page >= 2 && (
          <div className="breadLine2"></div>
        )}

        <button
          className={getBreadCrumbClassName(2)}
          onClick={() => setPage(2)}
          disabled={!isPreviousPageFilled(2)}
          aria-label="Schritt 3"
        >
          <p>3</p>
        </button>

        {/* Отображать линию только если текущая страница >= 3 */}
        {page >= 3 && (
          <div className="breadLine3"></div>
        )}

        <button
          className={getBreadCrumbClassName(3)}
          onClick={() => setPage(3)}
          disabled={!isPreviousPageFilled(3)}
          aria-label="Schritt 4"
        >
          <p>4</p>
        </button>
      </div>

      <div className="date-picker-content-wrapper">
        <div className="form-content">
          {conditionalComponent()}
        </div>
        <div className="form-overview">
          {currentData()}
        </div>
      </div>
    </div>
  );
}